import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import { LANGUAGES, ALIASES } from '../lib/highlight';

/**
 * Safe GFM markdown renderer. react-markdown does NOT render raw HTML (no
 * rehype-raw here), so user-authored notes/comments can't inject markup — the
 * XSS-safe default. remark-gfm adds tables, task-lists, strikethrough, and
 * autolinks (the GitHub/GitLab-flavored subset). rehype-highlight syntax-colors
 * fenced code blocks using the SAME curated grammar set as the editor (so a
 * ```json block reads identically here and in the composer). Wrapped in
 * `.md-body` for dark-theme element styling (globals.css). Links open in a new tab.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="md-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeHighlight, { languages: LANGUAGES, aliases: ALIASES, ignoreMissing: true, detect: false }]]}
        components={{
          a: ({ node: _n, ...props }) => <a {...props} target="_blank" rel="noreferrer noopener" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
